import Alert from "@mui/material/Alert";
import type { SxProps, Theme } from "@mui/material/styles";
import { useTranslation } from "react-i18next";
import { RESULTS_LIMIT_GROUP } from "@/constants/resultsLimits";
import { useGroups } from "@/hooks/groups/useGroups";

/**
 * Warns that the group list hit {@link RESULTS_LIMIT_GROUP}, so groups beyond the cap are missing
 * from trees, filters and pickers. Reads the cached `useGroups()` query; no extra Geotab call.
 */
export function GroupsTruncatedAlert({ sx }: { sx?: SxProps<Theme> }) {
  const { t } = useTranslation();
  const { isTruncated } = useGroups();
  if (!isTruncated) return null;
  return (
    <Alert severity="warning" sx={sx}>
      {t("common.groupsTruncated", { count: RESULTS_LIMIT_GROUP })}
    </Alert>
  );
}
